import { Icon } from './icon';

export function NoAccess() {
  return (
    <div className='mx-12 mt-12 flex flex-col items-center'>
      <Icon icon='mdi:lock-outline' width={48} className='text-default-500' />
      <div className='mt-2 text-center'>You do not have access</div>
    </div>
  );
}
